import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from "vue";

type SnowflakeStyle = {
  left: string;
  fontSize: string;
  animationDuration: string;
  animationDelay: string;
  opacity: string;
};

type Snowflake = {
  id: number;
  style: SnowflakeStyle;
};

const INITIAL_FLAKE_COUNT = 12;
const DURATION_MS: number = 2 * 60 * 1000;
const TICK_MS = 1000;


export default /*@__PURE__*/_defineComponent({
  __name: 'SnowOverlay',
  setup(__props) {

const flakes = ref<Snowflake[]>(
  Array.from({ length: INITIAL_FLAKE_COUNT }, (_, index: number): Snowflake => {
    const size: number = 8 + Math.random() * 8;
    const duration: number = 14 + Math.random() * 8;
    const delay: number = Math.random() * 10;
    const left: number = Math.random() * 100;
    const opacity: number = 0.15 + Math.random() * 0.2;

    return {
      id: index,
      style: {
        left: `${left}%`,
        fontSize: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `-${delay}s`,
        opacity: `${opacity}`
      }
    };
  })
);

const elapsedMs = ref<number>(0);
const visibleCount = ref<number>(INITIAL_FLAKE_COUNT);

let intervalId: number | null = null;

const progress = computed<number>(() => {
  const ratio: number = elapsedMs.value / DURATION_MS;

  return Math.min(ratio, 1);
});

const overlayOpacity = computed<number>(() => 1 - progress.value);

const visibleFlakes = computed<Snowflake[]>((): Snowflake[] =>
  flakes.value.slice(0, visibleCount.value)
);

onMounted((): void => {
  intervalId = window.setInterval((): void => {
    elapsedMs.value = Math.min(elapsedMs.value + TICK_MS, DURATION_MS);

    const nextCount: number = Math.round(INITIAL_FLAKE_COUNT * (1 - progress.value));
    visibleCount.value = Math.max(nextCount, 0);

    if (elapsedMs.value >= DURATION_MS && intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }, TICK_MS);
});

onBeforeUnmount((): void => {
  if (intervalId !== null) {
    window.clearInterval(intervalId);
    intervalId = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "snow-overlay",
    "aria-hidden": "true",
    style: _normalizeStyle({ opacity: overlayOpacity.value.toString() })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFlakes.value, (flake) => {
      return (_openBlock(), _createElementBlock("span", {
        key: flake.id,
        class: "snowflake",
        style: _normalizeStyle(flake.style)
      }, " ❄ ", 4))
    }), 128))
  ], 4))
}
}

})